import { configureStore } from '@reduxjs/toolkit';
import sidebarReducer from '../reducers/sidebarSlice';
import toastBoxReducer from './ToastBoxSlice';

const store = configureStore({
  reducer: {
    sidebar: sidebarReducer,
    toastBox: toastBoxReducer,
  },
});

export default store;
